// Constants
import { PremiumPlanLicenseLevel } from "./configuration/premiumPlanSettings/FeatureEntitlements";
/**
 * Ordered numeric tiers for premium plan licenses.
 * Higher values indicate higher license tiers, enabling direct comparison with >=, >, etc.
 */ export var PremiumLicenseTier = /*#__PURE__*/ function(PremiumLicenseTier) {
    PremiumLicenseTier[PremiumLicenseTier["None"] = 0] = "None";
    PremiumLicenseTier[PremiumLicenseTier["P1"] = 1] = "P1";
    PremiumLicenseTier[PremiumLicenseTier["P3"] = 2] = "P3";
    PremiumLicenseTier[PremiumLicenseTier["P5"] = 3] = "P5";
    return PremiumLicenseTier;
}({});
/**
 * Maps premium plan license levels to their corresponding license tiers.
 */ export const PremiumLicenseLevelToTierMapping = {
    [PremiumPlanLicenseLevel.basic]: 0,
    [PremiumPlanLicenseLevel.basicPlus]: 0,
    [PremiumPlanLicenseLevel.standard]: 1,
    [PremiumPlanLicenseLevel.professional]: 2,
    [PremiumPlanLicenseLevel.premium]: 3
};
